import * as tslib_1 from "tslib";
import { AttachmentFileType } from 'owa-attachment-common';
import { ApiError, ApiErrorCode } from 'owa-addins-core';
import { lazyDeleteAttachmentsViaQueueManager } from 'owa-attachment-well-data';
import addFile from 'owa-mail-compose-store/lib/utils/addFile';
import addItem from 'owa-mail-compose-store/lib/utils/addItem';
import { getCurrentTableMailboxInfo } from 'owa-mail-mailboxinfo';
import { infoBarAddHandler, infoBarRemoveHandler, } from 'owa-mail-compose-store/lib/utils/infoBarHandlers';
function getAttachmentError(messageId) {
    switch (messageId) {
        case 'ErrorTooLargeForLocalAttachmentSingle':
        case 'ErrorTooLargeForLocalAttachmentMultiple':
            return ApiErrorCode.AttachmentSizeExceeded;
        default:
            return ApiErrorCode.AttachmentUploadGeneralFailure;
    }
}
export var addItemAttachment = function (viewState) { return function (attachmentName, itemId, isInline) {
    return addItem(viewState, attachmentName, itemId, isInline).catch(handleError);
}; };
function handleError(error) {
    throw error.messageId
        ? getAttachmentError(error.messageId)
        : ApiErrorCode.AttachmentUploadGeneralFailure;
}
export var addFileAttachment = function (viewState) { return function (attachmentName, uri, isInline) {
    return addFile(viewState, attachmentName, uri, isInline).catch(handleError);
}; };
function getAttachmentState(attachmentStates, attachmentId) {
    var foundStates = attachmentStates.filter(function (state) { return state.attachmentId.Id === attachmentId; });
    return foundStates.length > 0 ? foundStates[0] : null;
}
export var removeAttachment = function (viewState) { return function (attachmentId) {
    return new Promise(function (resolve, reject) {
        lazyDeleteAttachmentsViaQueueManager.import().then(function (deleteAttachmentViaQueueManager) {
            try {
                var attachmentState = getAttachmentState(viewState.attachmentWell.docViewAttachments, attachmentId);
                if (!attachmentState) {
                    attachmentState = getAttachmentState(viewState.attachmentWell.imageViewAttachments, attachmentId);
                }
                if (!attachmentState) {
                    attachmentState = getAttachmentState(viewState.attachmentWell.inlineAttachments, attachmentId);
                }
                if (!attachmentState) {
                    reject(new ApiError(ApiErrorCode.AttachmentToDeleteDoesNotExist));
                    return;
                }
                var parentItemId = tslib_1.__assign({}, viewState.itemId, { mailboxInfo: getCurrentTableMailboxInfo() });
                deleteAttachmentViaQueueManager(viewState.attachmentWell, attachmentState, parentItemId, infoBarAddHandler(viewState), infoBarRemoveHandler(viewState));
                resolve();
            }
            catch (_a) {
                reject(new ApiError(ApiErrorCode.AttachmentDeleteGeneralFailure));
            }
        });
    });
}; };
export var hasInlineImage = function (attachments) {
    if (!attachments || attachments.length == 0) {
        return false;
    }
    var existing = attachments.some(function (attachment) {
        return attachment.file.fileType == AttachmentFileType.Uri && attachment.isInline;
    });
    return existing;
};
//# sourceMappingURL=AttachmentAdapter.js.map